import React from 'react';

class Video extends React.Component {
  constructor(props) {
    super(props);
    this.url=props.data
}
    
   render() {
    return (
  
      <div class="margin_tob_video_help_page">
      <iframe
      width="5400" 
      className='iframe-shopify-popup'               
      src={this.url}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen    >
      </iframe></div>
    )
  }
}

export default Video;